import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import NoDataHere from "../Img/nodatahere.png";

export const DataNotFound = ({msg}) => {
  return (
    <div
      className="hstack justify-content-center align-items-center"
      style={{ height: "-webkit-fill-available" }}
    >
      <div className="text-center" style={{ pointerEvents: "none", userSelect: "none" }}>
        <img src={NoDataHere} style={{ width: 200, opacity: .1 }} alt="" />
        <p className="text-muted small m-0">{msg}</p>
      </div>
    </div>
  );
};

export const ListLoader = () => {
  return (
    <div
      className="hstack justify-content-center align-items-center"
      style={{ height: "-webkit-fill-available" }}
    >
      <DotLottieReact
        src="https://lottie.host/253fda89-8e6c-4496-94d9-c9a9cb8d12ea/M1XD5pisuT.lottie"
        loop
        autoplay
        style={{ width: 500, height: 250 }}
      />
    </div>
  );
};

export const PageLoader = () => {
  return (
    <div
      className="hstack justify-content-center align-items-center"
      style={{ height: "-webkit-fill-available" }}
    >
      <DotLottieReact
        src="https://lottie.host/85c4f7e0-d0ee-4a11-b2fe-2fe2d03f6b6e/68Cx71lG5s.lottie"
        loop
        autoplay
        style={{ width: 500, height: 250 }}
      />
    </div>
  );
};

export const WaveLoader = () => {
  return (
    <div
      className="hstack justify-content-center align-items-center"
      style={{ height: "-webkit-fill-available" }}
    >
      <div className="wave-container">
        {Array.from({ length: 10 }).map((_, index) => (
          <span
            key={index}
            className="wave-star"
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            ★
          </span>
        ))}
      </div>
    </div>
  );
};
